import { getBonzahPDF } from "api/bonzah/bonzah";
import React from "react";
import toast from "react-hot-toast";
import { formatDateToHumanFirendly } from "utils/date-format";
import { sanitizeHtml } from "utils/sanitizeHtml";

function RentalAgreement({ data }: { data: any }) {
  function formatDate(dateString: string) {
    const date = new Date(dateString);

    // Correct options for formatting the date
    const options: Intl.DateTimeFormatOptions = {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
      timeZone: "UTC",
    };

    // Get the formatted date
    const formattedDate = date.toLocaleString("en-GB", options);

    return formattedDate;
  }
  function toSentenceCase(str: string) {
    if (!str || typeof str !== "string") return str; // Return as is if not a string

    // Convert the first letter to uppercase and the rest to lowercase
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const formatDatetoyear = (isoDateString: Date) => {
    if (!isoDateString) return "Invalid date"; // Handle undefined/null dates
    const dateObj = new Date(isoDateString);
    return dateObj.toISOString().split("T")[0]; // Convert to YYYY-MM-DD format
  };

  function extractSubstringInBrackets(input: string) {
    if (typeof input !== "string") {
      throw new Error("Input must be a string.");
    }

    // Use a regular expression to match the content inside round brackets
    const match = input.match(/\(([^)]+)\)/);

    // Return the captured content or null if no match
    return match ? match[1] : null;
  }

  return (
    <>
     
      <div className="mt-6 rounded-lg border bg-white p-4">
        <div className="mb-8">
          <h1 className="text-lg font-bold text-[#00283E]">
            Terms & Conditions
          </h1>
          <p className="max-96 text-sm text-[#86909C]">
            {`Please note the following booking Terms and Conditions apply to
         bookings placed directly on the ${data.company?.name} website.`}
          </p>
        </div>
        <div className="col-span-12 @container">
          <div className="flex flex-col gap-y-4">
            {data?.content?.terms_condition?.map((item: any, i: number) => {
              return (
                <div className="rounded-lg border border-muted" key={i}>
                  <div className="header rounded-lg bg-[#f7f7f7] px-5 py-3">
                    <h4 className="text-lg">
                      {i + 1}. {item?.title}
                    </h4>
                  </div>

                  <div className="header border-t border-muted p-5 w-full">
                    <div className="grid grid-cols-1 gap-3 rounded-lg w-full">
                      <div
                        className="prose prose-sm text-gray-500 break-words"
                        style={{ maxWidth: "100%" }} // Manually remove the max width
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHtml(item?.content),
                        }}
                      />
                    </div>
                  </div>               
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}

export default RentalAgreement;
